import { UserRole } from 'enums';
import { useBoolean, useCurrentUser, useMutateNylasUser } from 'hooks';

export function useRevokeNylasGrant() {
  const [isLoading, { off: stopRevokeGrant, on: startRevokeGrant }] = useBoolean(false);
  const { revokeGrant } = useMutateNylasUser();
  const { me, endUser } = useCurrentUser();

  const revokeNylasGrant = async () => {
    startRevokeGrant();
    if (me?.role === UserRole.CapitolaBroker) {
      await revokeGrant.mutateAsync({ id: endUser?.id ?? me.id });
    }
    stopRevokeGrant();
  };

  return { revokeNylasGrant, isLoading };
}
